/* MoRetro Studio V23.0 — Commandes boutique Shopify */
window.MTS = window.MTS || {};
(function(MTS){
  "use strict";
  const API_BASE = "https://bubbly-vibrancy-production.up.railway.app";

  function injectOrdersCss(){
    if(document.getElementById("mtsOrdersV232Css")) return;
    const style=document.createElement("style");
    style.id="mtsOrdersV232Css";
    style.textContent=`
      .mts-order-cancelled{
        border-color:rgba(255,43,43,.30)!important;
        background:rgba(255,43,43,.08)!important;
      }
      .mts-badge.archived{
        background:rgba(255,43,43,.12)!important;
        color:#ffbdbd!important;
      }
    `;
    document.head.appendChild(style);
  }


  function money(v,c="EUR"){try{return new Intl.NumberFormat("fr-FR",{style:"currency",currency:c}).format(Number(v||0));}catch(e){return (Number(v||0)).toFixed(2).replace(".",",")+" €";}}
  function dateLabel(v){try{return v?new Date(v).toLocaleString("fr-FR",{dateStyle:"short",timeStyle:"short"}):"";}catch(e){return "";}}

  function frenchStatus(status,type="payment",order=null){
    if(order && order.cancelledAt) return "Annulée";

    const raw=String(status||"").toUpperCase();

    const payment={
      PAID:"Payé",
      PENDING:"En attente",
      AUTHORIZED:"Autorisé",
      PARTIALLY_PAID:"Partiellement payé",
      PARTIALLY_REFUNDED:"Partiellement remboursé",
      REFUNDED:"Remboursé",
      VOIDED:"Annulé",
      EXPIRED:"Expiré"
    };

    const fulfillment={
      FULFILLED:"Expédiée",
      UNFULFILLED:"À préparer",
      PARTIALLY_FULFILLED:"Partiellement expédiée",
      IN_PROGRESS:"En préparation",
      ON_HOLD:"En attente",
      OPEN:"Ouverte",
      RESTOCKED:"Remise en stock",
      PENDING_FULFILLMENT:"Préparation en attente"
    };

    return (type==="fulfillment" ? fulfillment[raw] : payment[raw]) || raw || "—";
  }

  function isCancelled(order=null){
    return !!(order && order.cancelledAt);
  }

  function countsInRevenue(order=null){
    if(!order) return false;
    const fs=String(order.financialStatus||"").toUpperCase();
    if(isCancelled(order)) return false;
    if(["REFUNDED","VOIDED","CANCELLED"].includes(fs)) return false;
    return fs==="PAID" || fs==="PARTIALLY_PAID";
  }


  function badge(status,type="payment",order=null){
    const raw=String(status||"").toUpperCase();
    let cls="pending";

    if(isCancelled(order)){
      cls="archived";
      return `<span class="mts-badge ${cls}">⛔ ${MTS.escapeHtml(frenchStatus(status,type,order))}</span>`;
    }

    if(["PAID","FULFILLED"].includes(raw)) cls="paid";
    if(["AUTHORIZED","PARTIALLY_PAID","IN_PROGRESS","UNFULFILLED","PARTIALLY_FULFILLED","ON_HOLD"].includes(raw)) cls="quoted";
    if(["REFUNDED","VOIDED","CANCELLED"].includes(raw)) cls="archived";

    return `<span class="mts-badge ${cls}">${MTS.escapeHtml((type==="payment"?"💳 ":"📦 ")+frenchStatus(status,type,order))}</span>`;
  }
  function shopifyAdminUrl(o){const id=String(o.legacyResourceId||"").trim();return id?`https://admin.shopify.com/store/moretro3d/orders/${encodeURIComponent(id)}`:"https://admin.shopify.com/store/moretro3d/orders";}
  async function loadOrders(force=false){
    if(!force && MTS.state.orders?.length) return MTS.state.orders;
    MTS.html("mtsShopOrdersList",`<div class="mts-empty">Chargement des commandes Shopify...</div>`);
    const res=await fetch(`${API_BASE}/api/shopify/orders?first=50&query=${encodeURIComponent("status:any")}`,{headers:{accept:"application/json"}});
    const data=await res.json().catch(()=>null);
    if(!res.ok || !data?.ok){const msg=data?.error||`Erreur Shopify ${res.status}`;MTS.html("mtsShopOrdersList",`<div class="mts-empty">Erreur commandes Shopify : ${MTS.escapeHtml(msg)}</div>`);throw new Error(msg);}
    MTS.state.orders=data.orders||[];
    MTS.state.ordersLoadedAt=new Date().toISOString();
    syncCancelledOrders().catch(err=>console.warn("Sync annulations Shopify :", err.message));
    render();
    return MTS.state.orders;
  }
  function filteredOrders(){
    const q=String(MTS.$("mtsShopOrdersSearch")?.value||"").toLowerCase().trim();
    const st=String(MTS.$("mtsShopOrdersStatus")?.value||"all");
    return (MTS.state.orders||[]).filter(o=>{
      const hay=[o.name,o.customerName,o.email,...(o.items||[]).map(i=>i.title),...(o.items||[]).map(i=>i.sku)].join(" ").toLowerCase();
      const okQ=!q||hay.includes(q);
      const fs=String(o.financialStatus||"").toUpperCase(), ful=String(o.fulfillmentStatus||"").toUpperCase();
      const okS=st==="all"||(st==="paid"&&countsInRevenue(o))||(st==="unfulfilled"&&!o.cancelledAt&&ful.includes("UNFULFILLED"))||(st==="fulfilled"&&!o.cancelledAt&&ful.includes("FULFILLED"))||(st==="cancelled"&&!!o.cancelledAt);
      return okQ&&okS;
    });
  }
  function renderList(){
    const list=MTS.$("mtsShopOrdersList"); if(!list)return;
    const orders=filteredOrders();
    if(!orders.length){list.innerHTML=`<div class="mts-empty">Aucune commande boutique.</div>`;MTS.html("mtsShopOrderDetail",`<div class="mts-empty">Sélectionne une commande à gauche.</div>`);return;}
    if(!MTS.state.selectedOrderId || !orders.some(o=>o.id===MTS.state.selectedOrderId)) MTS.state.selectedOrderId=orders[0].id;
    list.innerHTML=orders.map(o=>{const qty=(o.items||[]).reduce((s,i)=>s+Number(i.quantity||0),0);return `<button type="button" class="mts-crm-item ${o.id===MTS.state.selectedOrderId?"active":""}" data-order-id="${MTS.escapeHtml(o.id)}"><div class="mts-crm-item-top"><strong>${MTS.escapeHtml(o.name||"Commande Shopify")}</strong>${badge(o.financialStatus,"payment",o)}</div><span>${MTS.escapeHtml(o.customerName||"Client")}<br>${qty} article(s) — ${money(o.total,o.currency)}<br>${o.cancelledAt ? "⛔ Annulée — " : ""}${MTS.escapeHtml(dateLabel(o.createdAt))}</span></button>`;}).join("");
    list.querySelectorAll("[data-order-id]").forEach(b=>b.addEventListener("click",()=>{MTS.state.selectedOrderId=b.dataset.orderId;renderList();renderDetail();}));
    renderDetail();
  }
  function renderAddress(a={}){const lines=[a.name,a.company,a.address1,a.address2,[a.zip,a.city].filter(Boolean).join(" "),a.province,a.country,a.phone].filter(Boolean);return lines.length?lines.map(MTS.escapeHtml).join("<br>"):"Adresse non disponible";}
  function renderItems(o){const items=o.items||[];return items.length?`<div class="mts-shop-items">${items.map(i=>`<div class="mts-shop-item">${i.image?`<img src="${MTS.escapeHtml(i.image)}" alt="${MTS.escapeHtml(i.imageAlt||i.title)}" loading="lazy">`:`<div class="mts-shop-item-img">📦</div>`}<div><strong>${MTS.escapeHtml(i.title||"Produit")}</strong><span>Qté : ${Number(i.quantity||0)}${i.sku?` • SKU : ${MTS.escapeHtml(i.sku)}`:""}${i.variantTitle&&i.variantTitle!=="Default Title"?`<br>Variante : ${MTS.escapeHtml(i.variantTitle)}`:""}</span></div><em>${money(i.total||(i.unitPrice*i.quantity),i.currency||o.currency)}</em></div>`).join("")}</div>`:`<div class="mts-empty">Aucun produit dans cette commande.</div>`;}
  function renderDetail(){
    const box=MTS.$("mtsShopOrderDetail"); if(!box)return;
    const o=(MTS.state.orders||[]).find(x=>x.id===MTS.state.selectedOrderId);
    if(!o){box.innerHTML=`<div class="mts-empty">Sélectionne une commande à gauche.</div>`;return;}
    const qty=(o.items||[]).reduce((s,i)=>s+Number(i.quantity||0),0);
    box.innerHTML=`<div class="mts-detail-head"><div><h3>🛒 ${MTS.escapeHtml(o.name||"Commande Shopify")}</h3><p>${MTS.escapeHtml(o.customerName||"Client Shopify")} — ${MTS.escapeHtml(o.email||"email non disponible")}<br>${MTS.escapeHtml(dateLabel(o.createdAt))}</p></div><div class="mts-actions">${badge(o.financialStatus,"payment",o)}${badge(o.fulfillmentStatus,"fulfillment",o)}</div></div>
    <div class="mts-detail-grid"><div class="mts-detail-box"><span>Montant payé</span><strong>${money(o.total,o.currency)}</strong></div><div class="mts-detail-box"><span>Articles</span><strong>${qty}</strong></div><div class="mts-detail-box"><span>Sous-total</span><strong>${money(o.subtotal,o.currency)}</strong></div><div class="mts-detail-box"><span>Livraison</span><strong>${money(o.shippingTotal,o.currency)}</strong></div></div>
    <div class="mts-detail-message"><span>📦 Produits commandés</span>${renderItems(o)}</div>
    <div class="mts-detail-message"><span>👤 Client / livraison</span><p>${renderAddress(o.shippingAddress)}</p></div>
    <div class="mts-detail-message"><span>🚚 Suivi</span><p>${o.trackingNumber?`${MTS.escapeHtml(o.trackingCompany||"Transporteur")} — ${MTS.escapeHtml(o.trackingNumber)}${o.trackingUrl?`<br><a href="${MTS.escapeHtml(o.trackingUrl)}" target="_blank" rel="noopener">Ouvrir le suivi</a>`:""}`:"Aucun suivi enregistré pour l’instant."}</p></div>
    <div class="mts-project-main-actions" style="display:flex!important"><a class="mts-btn mts-soft" href="${MTS.escapeHtml(shopifyAdminUrl(o))}" target="_blank" rel="noopener">📄 Voir sur Shopify</a><button type="button" class="mts-btn mts-ok" id="mtsCreateOrderProduction">🖨️ Créer production</button><button type="button" class="mts-btn mts-soft" id="mtsSendOrderMail">📧 Envoyer un mail</button><button type="button" class="mts-btn mts-soft" id="mtsPrepareShippingLabel">📦 Étiquette Sendcloud</button></div>
    ${o.cancelledAt ? `<div class="mts-detail-message mts-order-cancelled"><span>⚠️ Commande annulée</span><p>Annulée le ${MTS.escapeHtml(dateLabel(o.cancelledAt))}${o.cancelReason?`<br>Raison : ${MTS.escapeHtml(o.cancelReason)}`:""}</p></div>` : ""}
    <div class="mts-detail-message"><span>📜 Historique boutique</span><p>Commande créée : ${MTS.escapeHtml(dateLabel(o.createdAt))}<br>Paiement : ${MTS.escapeHtml(frenchStatus(o.financialStatus,"payment",o))}<br>Expédition : ${MTS.escapeHtml(frenchStatus(o.fulfillmentStatus,"fulfillment",o))}</p></div>`;
    MTS.on("mtsCreateOrderProduction","click",()=>openProductionModal(o));
    MTS.on("mtsSendOrderMail","click",()=>alert("V23.1 : mails boutique."));
    MTS.on("mtsPrepareShippingLabel","click",()=>{
      if(!MTS.Shipping){
        alert("Module mts-shipping.js manquant.");
        return;
      }
      MTS.Shipping.openShippingModal(MTS.Shipping.shippingPayloadFromOrder(o));
    });
  }


  const RECIPE_KEY = "moretroStudioProductRecipesV23";

  function loadRecipes(){
    try{
      return JSON.parse(localStorage.getItem(RECIPE_KEY) || "{}");
    }catch(e){
      return {};
    }
  }

  function saveRecipes(recipes){
    try{
      localStorage.setItem(RECIPE_KEY, JSON.stringify(recipes || {}));
    }catch(e){}
  }

  function recipeKey(item = {}){
    return String(item.sku || item.productHandle || item.title || item.name || "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g,"-")
      .replace(/[^a-z0-9\-_]/g,"");
  }

  function recipeForItem(item = {}){
    const key = recipeKey(item);
    const recipes = loadRecipes();
    return key ? (recipes[key] || null) : null;
  }

  function saveRecipeForLine(line = {}){
    const key = recipeKey(line);
    if(!key) return;

    const recipes = loadRecipes();
    recipes[key] = {
      title:line.title || "",
      sku:line.sku || "",
      printer:line.printer || "",
      materialId:line.materialId || "",
      materialName:line.materialName || "",
      color:line.color || "",
      updatedAt:new Date().toISOString()
    };
    saveRecipes(recipes);
  }

  function orderProjectDocId(order = {}){
    return `shopify-${String(order.legacyResourceId || order.id || "").replace(/\W+/g,"-")}`;
  }

  async function syncCancelledOrders(){
    if(!MTS.state.db) return;

    const cancelled = (MTS.state.orders || []).filter(o=>o.cancelledAt);
    if(!cancelled.length) return;

    for(const order of cancelled){
      try{
        const docId = orderProjectDocId(order);
        const ref = MTS.state.db.collection("custom_requests").doc(docId);
        const snap = await ref.get();

        // On ne crée pas de nouveau projet annulé si la production n'avait jamais été créée.
        if(!snap.exists) continue;

        const current = snap.data() || {};
        if(current.shopifyCancelled === true || current.status === "archived") continue;

        const history = Array.isArray(current.history) ? current.history : [];
        history.push({
          type:"shopify_cancelled",
          label:`Commande Shopify ${order.name || ""} annulée`,
          date:new Date().toISOString()
        });

        await ref.set({
          status:"archived",
          displayStatus:"cancelled",
          shopifyCancelled:true,
          cancelledAt:order.cancelledAt,
          cancelReason:order.cancelReason || "",
          history,
          shopify:{
            ...(current.shopify || {}),
            cancelledAt:order.cancelledAt,
            cancelReason:order.cancelReason || "",
            financialStatus:order.financialStatus || current.shopify?.financialStatus || "",
            fulfillmentStatus:order.fulfillmentStatus || current.shopify?.fulfillmentStatus || ""
          },
          updatedAt:firebase.firestore.FieldValue.serverTimestamp()
        }, {merge:true});
      }catch(err){
        console.warn("Sync annulation Shopify impossible :", order.name, err.message);
      }
    }
  }


  function injectProductionModalCss(){
    if(document.getElementById("mtsOrderProductionCss")) return;
    const style=document.createElement("style");
    style.id="mtsOrderProductionCss";
    style.textContent=`
      .mts-order-prod-modal{position:fixed;inset:0;z-index:9999;background:rgba(0,0,0,.72);display:grid;place-items:center;padding:20px}
      .mts-order-prod-card{width:min(980px,100%);max-height:92vh;overflow:auto;border-radius:28px;background:#101018;border:1px solid rgba(255,255,255,.14);box-shadow:0 30px 120px rgba(0,0,0,.55);padding:20px}
      .mts-order-prod-head{display:flex;justify-content:space-between;align-items:flex-start;gap:16px;margin-bottom:16px}
      .mts-order-prod-head h3{margin:0;color:#fff;font-size:24px}.mts-order-prod-head p{margin:7px 0 0;color:#aaa;font-size:13px;line-height:1.4}
      .mts-order-prod-close{border:0;background:rgba(255,255,255,.08);color:#fff;border-radius:14px;width:38px;height:38px;font-size:24px;cursor:pointer}
      .mts-order-prod-list{display:grid;gap:12px}
      .mts-order-prod-row{display:grid;grid-template-columns:1.4fr .55fr .9fr 1fr .8fr;gap:10px;align-items:end;padding:14px;border-radius:20px;background:rgba(255,255,255,.045);border:1px solid rgba(255,255,255,.08)}
      .mts-order-prod-title strong{display:block;color:#fff;font-size:14px}.mts-order-prod-title span{display:block;margin-top:5px;color:#aaa;font-size:12px;line-height:1.35}
      .mts-order-prod-row label{display:grid;gap:7px;color:#fff;font-size:12px;font-weight:900}
      .mts-order-prod-row input,.mts-order-prod-row select{width:100%;border:1px solid rgba(255,255,255,.14);border-radius:14px;background:#101010;color:#fff;padding:11px 12px;font-family:'Fredoka',sans-serif;outline:none}
      .mts-order-prod-actions{display:flex;justify-content:flex-end;gap:10px;margin-top:16px}
      @media(max-width:980px){.mts-order-prod-row{grid-template-columns:1fr 1fr}.mts-order-prod-title{grid-column:1/-1}}
      @media(max-width:560px){.mts-order-prod-row,.mts-order-prod-actions,.mts-order-prod-head{display:grid;grid-template-columns:1fr}}
    `;
    document.head.appendChild(style);
  }
  function studioPrinters(){
    if(MTS.Settings && typeof MTS.Settings.activePrinters==="function") return MTS.Settings.activePrinters();
    return ["Ender 3 V3 SE #1","Ender 3 V3 SE #2","Sidewinder X4 Plus","Kobra S1","P2S #1","P2S #2","H2D"].map(name=>({name}));
  }
  function studioMaterials(){
    if(MTS.Settings && typeof MTS.Settings.activeFilaments==="function") return MTS.Settings.activeFilaments();
    return [];
  }
  function materialLabel(f={}){
    const isResin=f.type==="resin"||String(f.material||"").toLowerCase().includes("résine")||String(f.material||"").toLowerCase().includes("resine");
    const stock=isResin?`${Number(f.remainingVolumeL||0).toFixed(2).replace(".",",")} L`:`${Number(f.remainingG||0)} g`;
    return [f.name,[f.brand,f.material,f.color].filter(Boolean).join(" "),stock?`(${stock})`:""].filter(Boolean).join(" ");
  }
  function printerOptions(selected=""){
    return studioPrinters().map(p=>{
      const name=p.name||p.model||"Imprimante";
      return `<option value="${MTS.escapeHtml(name)}" ${name===selected?"selected":""}>${MTS.escapeHtml(name)}</option>`;
    }).join("");
  }
  function materialOptions(selected=""){
    const mats=studioMaterials();
    if(!mats.length){
      return `<option value="">Aucun filament configuré</option><option value="PLA Noir" ${selected==="PLA Noir"?"selected":""}>PLA Noir</option><option value="PLA Blanc" ${selected==="PLA Blanc"?"selected":""}>PLA Blanc</option><option value="PETG Noir" ${selected==="PETG Noir"?"selected":""}>PETG Noir</option>`;
    }
    return `<option value="">Choisir</option>`+mats.map(f=>{
      const id=f.id||f.name||[f.brand,f.material,f.color].filter(Boolean).join(" ");
      return `<option value="${MTS.escapeHtml(id)}" ${id===selected?"selected":""}>${MTS.escapeHtml(materialLabel(f))}</option>`;
    }).join("");
  }
  function findMaterial(id){
    return studioMaterials().find(f=>String(f.id||f.name||"")===String(id))||null;
  }
  function colorGuess(item={}){
    const txt=[item.title,item.name,item.variantTitle,item.sku].filter(Boolean).join(" ").toLowerCase();
    return ["noir","blanc","rouge","bleu","vert","jaune","orange","violet","rose","gris","transparent","or","argent","cuivre"].find(c=>txt.includes(c))||"";
  }
  function buildProductionLines(order){
    return (order.items||[]).map((item,index)=>{
      const recipe = recipeForItem(item) || {};
      return {
        id:item.id||`item-${index}`,
        title:item.title||item.name||"Produit",
        sku:item.sku||"",
        productHandle:item.productHandle || "",
        quantity:Math.max(1,Number(item.quantity||1)),
        printer:recipe.printer || "",
        materialId:recipe.materialId || "",
        materialName:recipe.materialName || "",
        color:recipe.color || colorGuess(item),
        hasRecipe:!!recipe.printer || !!recipe.materialId || !!recipe.color,
        status:"waiting"
      };
    });
  }
  function openProductionModal(order){
    injectProductionModalCss();
    document.getElementById("mtsOrderProductionModal")?.remove();
    const lines=buildProductionLines(order);
    const modal=document.createElement("div");
    modal.id="mtsOrderProductionModal";
    modal.className="mts-order-prod-modal";
    modal.innerHTML=`<div class="mts-order-prod-card">
      <div class="mts-order-prod-head"><div><h3>🖨️ Créer la production</h3><p>${MTS.escapeHtml(order.name||"Commande Shopify")} — choisis l’imprimante et le filament/résine par produit.</p></div><button type="button" class="mts-order-prod-close" data-close-order-production>×</button></div>
      <div class="mts-order-prod-list">${lines.map((line,index)=>`<div class="mts-order-prod-row" data-production-line="${index}">
        <div class="mts-order-prod-title"><strong>${MTS.escapeHtml(line.title)}</strong><span>Qté Shopify : ${line.quantity}${line.sku?` • SKU : ${MTS.escapeHtml(line.sku)}`:""}${line.hasRecipe?`<br>✅ Fiche fabrication préremplie`:""}</span></div>
        <label>Quantité<input type="number" min="1" step="1" value="${line.quantity}" data-prod-field="quantity"></label>
        <label>Imprimante<select data-prod-field="printer"><option value="">Choisir</option>${printerOptions(line.printer)}</select></label>
        <label>Filament / résine<select data-prod-field="materialId">${materialOptions(line.materialId)}</select></label>
        <label>Couleur<input type="text" value="${MTS.escapeHtml(line.color)}" placeholder="Noir, blanc..." data-prod-field="color"></label>
      </div>`).join("")}</div>
      <div class="mts-order-prod-actions"><button type="button" class="mts-btn mts-soft" data-close-order-production>Annuler</button><button type="button" class="mts-btn mts-ok" id="mtsValidateOrderProduction">✅ Envoyer en production</button></div>
    </div>`;
    document.body.appendChild(modal);
    modal.querySelectorAll("[data-close-order-production]").forEach(btn=>btn.addEventListener("click",()=>modal.remove()));
    modal.addEventListener("click",e=>{if(e.target===modal)modal.remove();});
    modal.querySelectorAll('[data-prod-field="materialId"]').forEach(select=>select.addEventListener("change",()=>{const mat=findMaterial(select.value);const row=select.closest("[data-production-line]");const color=row?.querySelector('[data-prod-field="color"]');if(mat&&color&&!color.value)color.value=mat.color||"";}));
    document.getElementById("mtsValidateOrderProduction")?.addEventListener("click",()=>{
      const selected=Array.from(modal.querySelectorAll("[data-production-line]")).map((row,index)=>{const base=lines[index];const materialId=row.querySelector('[data-prod-field="materialId"]')?.value||"";const mat=findMaterial(materialId);return {...base,quantity:Number(row.querySelector('[data-prod-field="quantity"]')?.value||base.quantity||1),printer:row.querySelector('[data-prod-field="printer"]')?.value||"",materialId,materialName:mat?materialLabel(mat):materialId,materialType:mat?.type||"",brand:mat?.brand||"",material:mat?.material||"",color:row.querySelector('[data-prod-field="color"]')?.value||mat?.color||"",kgPrice:Number(mat?.kgPrice||0),literPrice:Number(mat?.literPrice||0)};});
      if(selected.some(l=>!l.printer)){alert("Choisis une imprimante pour chaque produit.");return;}

      selected.forEach(saveRecipeForLine);

      modal.remove();
      createProduction(order,selected);
    });
  }


  async function createProduction(o, productionLines=null){
    if(!MTS.state.db){alert("Firebase non disponible.");return;}
    const docId=`shopify-${String(o.legacyResourceId||o.id).replace(/\W+/g,"-")}`;
    const lines=Array.isArray(productionLines)&&productionLines.length?productionLines:buildProductionLines(o);
    const firstLine=lines[0]||{};
    const productionMessage=lines.map(l=>`${l.quantity||1}x ${l.title}${l.sku?" — SKU "+l.sku:""}\nImprimante : ${l.printer||"à définir"}\nMatière : ${l.materialName||l.materialId||"à définir"}${l.color?"\nCouleur : "+l.color:""}`).join("\n\n");
    const payload={source:"shopify_order",shopifyOrderId:o.id,shopifyOrderLegacyId:o.legacyResourceId||"",shopifyOrderName:o.name||"",status:"paid",name:o.customerName||"Client Shopify",email:o.email||"",projectType:`Commande boutique ${o.name||""}`,message:productionMessage,printerName:firstLine.printer||"",printer:firstLine.printer||"",selectedPrinter:firstLine.printer||"",filamentId:firstLine.materialId||"",filamentName:firstLine.materialName||"",filamentColor:firstLine.color||"",productionLines:lines,quote:{total:Number(o.total||0),price:Number(o.total||0),final:Number(o.total||0),source:"shopify_order"},finalPrice:Number(o.total||0),quoteTotal:Number(o.total||0),files:[],history:[{type:"shopify_import",label:`Commande Shopify ${o.name||""} importée`,date:new Date().toISOString()},{type:"production_config",label:`Production configurée : ${lines.length} ligne(s)`,date:new Date().toISOString()}],shopify:{orderId:o.id,legacyResourceId:o.legacyResourceId||"",name:o.name||"",financialStatus:o.financialStatus||"",fulfillmentStatus:o.fulfillmentStatus||"",total:Number(o.total||0),currency:o.currency||"EUR",items:o.items||[]},createdAt:firebase.firestore.FieldValue.serverTimestamp(),updatedAt:firebase.firestore.FieldValue.serverTimestamp()};
    try{await MTS.state.db.collection("custom_requests").doc(docId).set(payload,{merge:true});alert("Production créée dans Projets.");document.querySelector('[data-panel="projects"]')?.click();}catch(err){alert("Erreur création production : "+err.message);}
  }
  function updateDashboardRevenue(){const orders=MTS.state.orders||[];const shop=orders.filter(countsInRevenue).reduce((s,o)=>s+Number(o.total||0),0);const custom=(MTS.state.projects||[]).filter(p=>["paid","printing","finishing","ready","shipped","done"].includes(p.status||"")).reduce((s,p)=>s+Number(p.finalPrice||p.quoteTotal||p.quote?.total||p.autoQuote?.quote?.suggested||0),0);const box=MTS.$("mtsRevenueGlobal"); if(box) box.innerHTML=`<article><span>CA boutique</span><strong>${money(shop)}</strong><em>Commandes payées chargées</em></article><article><span>CA sur mesure</span><strong>${money(custom)}</strong><em>Projets payés / produits</em></article><article><span>CA global</span><strong>${money(shop+custom)}</strong><em>Boutique + sur mesure</em></article>`;}
  function render(){renderList();updateDashboardRevenue();}
  function bind(){MTS.on("mtsRefreshOrders","click",()=>loadOrders(true).catch(e=>alert("Erreur commandes : "+e.message)));["mtsShopOrdersSearch","mtsShopOrdersStatus"].forEach(id=>{const el=MTS.$(id);if(el)el.addEventListener(el.tagName==="SELECT"?"change":"input",renderList);});}
  function start(){injectOrdersCss();bind();document.querySelector('[data-panel="shop"]')?.addEventListener("click",()=>{if(!MTS.state.orders?.length)loadOrders(true).catch(e=>console.warn(e.message));else render();});setTimeout(()=>loadOrders(false).catch(()=>{}),1500);}
  MTS.Orders={start,loadOrders,render,renderList,renderDetail,updateDashboardRevenue};
})(window.MTS);
